import React, { type PropsWithChildren, useCallback, useEffect, useState } from "react";

//import AtlLayout from "brands/atlantic/layout";
import { Outlet, useLocation } from "react-router";
import { Maintenance } from "components/Maintenance";
import useMaintenance from "utils/hooks/useMaintenance";
import useTranslation from "utils/hooks/useTranslation";
import Loader from "components/shared/loader";
// import { useGetMaintenanceQuery } from "store/api";
import {
    BrandComponent,
    useBrandComponent
} from '../brands/useBrandComponentHook';
import { initYup, scrollToWindowTop } from "utils/helpers";


const Layout: React.FC<PropsWithChildren<{ hasBrandLayout?: boolean }>> = ({
  hasBrandLayout = true,
}) => {
  const [isMount, setIsMount] = useState(false);
  const { isInMaintenance, setIsInMaintenance } = useMaintenance();
  const { translations, t } = useTranslation();
  

  //const BrandLayout = AtlLayout;
  const BrandLayout = useBrandComponent(BrandComponent.Layout);

  const location = useLocation()
  
     useEffect(()=>{
      if (location.pathname.indexOf('/project/') === -1) {
        scrollToWindowTop(0)
      } else {
        scrollToWindowTop()
      }
     },[location])

  const setLocale = useCallback(() => {
    initYup()
  }, []);

  useEffect(() => {
    //dispatch(setCurrentLanguage(lang!));
    setIsMount(true);
  }, []); //eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    setLocale();
  }, [setLocale]);

  return translations ? (isInMaintenance ? (
    <BrandLayout simple={!hasBrandLayout}>
      <Maintenance
      setIsInMaintenance={setIsInMaintenance}
    />
    </BrandLayout>
    
  ) : isMount ? (
    <BrandLayout simple={!hasBrandLayout}>
      <Outlet />
    </BrandLayout>
  ) : (
    <></>
  )) : <Loader />;
};

export default Layout;
